export const getPartnerTier = (partnerTierInfo) => {
    if (partnerTierInfo?.minimumSpendCommitted) {
        return partnerTierInfo?.minimumSpendCommitTier.toLowerCase();
    }
    return partnerTierInfo?.partnerProgram?.partnerTier.toLowerCase();
}